export default __webpack_public_path__ + "static/media/quicksight.06f88bac.svg";